export function activateSidebarControls() {
	const sidebar = document.querySelector('.sidebar');
	let visible = false;

	if (sidebar) {
		document.querySelectorAll('.sidebar-control').forEach(control => {
			control.addEventListener('click', () => {
				if (visible) {
					document.body.classList.remove('fixed');
					sidebar.classList.remove('sidebar-expanded');
					sidebar.classList.add('sidebar-collapsed');
				} else {
					document.body.classList.add('fixed');
					sidebar.classList.remove('sidebar-collapsed');
					sidebar.classList.add('sidebar-expanded');
				}

				visible = !visible;
			}, false);
		});
	}
}

export function activateGlobalNavControls() {
	let visible = false;

	document.querySelectorAll('.global-nav-control').forEach(control => {
		control.addEventListener('click', () => {
			if (visible) {
				visible = false;
				control.classList.remove('active');
			} else {
				visible = true;
				control.classList.add('active');
			}
		}, false);
	});
}

export function activateLocalNavControls() {
	let visible = false;

	document.querySelectorAll('.local-nav-control').forEach(control => {
		control.addEventListener('click', () => {
			if (visible) {
				visible = false;
				control.classList.remove('active');
			} else {
				visible = true;
				control.classList.add('active');
			}
		}, false);
	});
}

export function activateMobileControls() {
	activateSidebarControls();
	activateGlobalNavControls();
	activateLocalNavControls();
}
